import { useEffect, useState } from 'react';
import useScript from 'react-script-hook';

import { createBridge } from '../../utils/manager';
import { BridgeConnectInstance, BridgeConnectOptions } from '../../types';


const BC_JS = 'https://static.bridge.com.do/connect/bridge-connect.js';

const useBridgeConnect = (options: BridgeConnectOptions) => {
  const [loading, error] = useScript({
    src: BC_JS,
    checkForExisting: true,
  });
  const [bridge, setBridge] = useState<BridgeConnectInstance | null>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!options.applicationId) {
      return;
    }

    if (error || !window.BridgeConnect) {
      console.error('Error loading BridgeConnect:', error);
      return;
    }

    if (bridge != null) {
      bridge.destroy()
    }


    const next = createBridge(
      {
        ...options,
        onInit: () => {
          setIframeLoaded(true);
          options.onInit && options.onInit();
        },
      },
      window.BridgeConnect.init
    );

    setBridge(next);

    return () => next.destroy();
  }, [
    loading,
    error,
    options.applicationId,
  ]);


  const ready = bridge != null && (!loading || iframeLoaded);

  const logIt = () => {
    if (!options.applicationId) {
      console.error('bridge-connect-react: open() called without a valid applicationId.');
    }
  };

  return {
    error,
    ready,
    open: bridge ? bridge.open : logIt,
  };
};

export default useBridgeConnect;